import { type InquiryStage } from "../../hooks/use-inquiries";

export function isInquiryTabActive(searchParam: string, statuses: InquiryStage[]): boolean {
  const searchParams = new URLSearchParams(searchParam);
  const stageParam = searchParams.get("stage");
  const statusFilter = stageParam?.split(",");
  return statusFilter?.every(status => statuses.includes(status as InquiryStage)) ?? false;
}
